import { render } from "./AppointmentsPerExpertBar.vue?vue&type=template&id=0720034e&scoped=true"
import script from "./AppointmentsPerExpertBar.vue?vue&type=script&lang=js"
export * from "./AppointmentsPerExpertBar.vue?vue&type=script&lang=js"

import "./AppointmentsPerExpertBar.vue?vue&type=style&index=0&id=0720034e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0720034e"]])

export default __exports__